import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const initialState = {
  daoTrangs: undefined, //[]
  daoTrangId: "",
  rawId: "",
  sheetHdr: undefined, // []
  sheetData: undefined, // []
  // daoTrang: undefined, // {}
  members: undefined, // [user]
  groups: undefined, // []
  status: "idle",
  filter: {
    keys: [],
    thanhPhans: []
  }
};

// user map
const map = new Map();

// load local stored data
function createMap(members) {
  map.clear();
  members.forEach((u) => map.set(u.email, u));
}

const ENABLE_CACHE = false;
function localSave(key, obj) {
  if (!ENABLE_CACHE) return;
  localStorage.setItem(key, JSON.stringify(obj));
}
function localRestore(key) {
  if (!ENABLE_CACHE) return;
  const text = localStorage.getItem(key);
  return JSON.parse(text);
}
function localLoadData() {
  if (!ENABLE_CACHE) return;
  try {
      initialState.daoTrangs = localRestore("daoTrangs");  
      initialState.daoTrangId = localRestore("daoTrangId");   // active daoTrang.id
      initialState.members = localRestore("members");         // active daoTrang.members
      initialState.groups = localRestore("groups");           // active daoTrang.groups
  } catch (ex) {
    console.log(ex.messages);
  }
}

localLoadData(); // reduce fecth on debug

export const fetchDataAsync = createAsyncThunk(
  "task/fetchData",
  async ({ token }) => {
    var res = await fetch(process.env.REACT_APP_API + "/api/configs", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: "",
    });
    if (res.status === 200) {
      var { startTime, endTime } = await res.json();
      return {
        startTime, // in seconds
        endTime,
      };
    } else {
      return null;
    }
  }
);

export const slice = createSlice({
  name: "task",
  initialState,
  reducers: {
    setSheetData: (state, action) => {
      console.log(action);
      state.sheetData = action.payload.sheetData;
    },
    setSheetHdr: (state, action) => {
      console.log(action);
      state.sheetHdr = action.payload.sheetHdr;
    },
    setCellData: (state, action) => {
      console.log(action);
      if (Array.isArray(action.payload)) {
        action.payload.forEach((c) => {
          var { iRow, iCol, val } = c;
          state.sheetData[iRow][iCol] = val;
        });
      }
    },
    setTaskRawId: (state, action) => {
      const { rawId } = action.payload;
      state.rawId = rawId;
    },
    setDaoTrangId: (state, action) => {
      const { daoTrangId } = action.payload;
      state.daoTrangId = daoTrangId;
    },
    setDaoTrangs: (state, action) => {
      const { daoTrangs } = action.payload;
      state.daoTrangs = daoTrangs;

      // local save
      localSave("daoTrangs", daoTrangs);
    },
    addDaoTrang: (state, action) => {
      const { daoTrang } = action.payload;
      if (!state.daoTrangs) {
        state.daoTrangs = [daoTrang];
      } else {
        if (state.daoTrangs.find((d) => d.id === daoTrang.id)) {
          state.daoTrangs.push(daoTrang);
        }
      }
    },
    
    editDaoTrang: (state, action) => {
      const { id, changes } = action.payload;
      const daoTrang = state.daoTrangs.find(dt=>dt.id === id)
      patch(daoTrang, changes)
    },
    deleteDaoTrang: (state, action) => {
      const { id } = action.payload;
      const idx = state.daoTrangs.findIndex(dt=>dt.id === id);
      state.daoTrangs.splice(idx,1);
    },
    setActiveDaoTrang: (state, action) => {
      const { daoTrangId, members } = action.payload;
      state.daoTrangId = daoTrangId;
      state.members = members;

      // clear prev data
      state.groups = undefined;
    },
    editUser: (state, action) => {
      const { id, changes } = action.payload;
      const user = state.members.find((u) => u.id === id);
      patch(user, changes);
    },
    addUser: (state, action) => {
      const { user } = action.payload;
      if (!state.members.find(u=>u.id === user.id)) {
        state.members.push(user);
      }
    },
    deleteUser: (state, action) => {
      const { userId } = action.payload;
      const index = state.members.findIndex(u=>u.id === userId)
      console.log(index, userId)
      if (index !== -1) {
        state.members.splice(index,1);
      }
    },
    updateActiveDaoTrang: (state, action) => {
      const { groups } = action.payload;
      state.groups = groups;

      // local store
      localSave("groups", groups);
    },
    addGroup: (state, action) => {
      const { group } = action.payload;
      if (group.id && !state.groups.find((g) => g.id === group.id)) {
        state.groups.push(group);
      }
    },
    setGroupChecked: (state, action) => {
      const { id, checked } = action.payload;
      state.groups.find(g=>g.id === id).checked = checked;
    },
    groupMoveUser: (state, action) => {
      console.log("moveUser");
      // dragContainer: {group: {id}, name}
      // dragUser: {email}
      var { dragContainer, dragUser, dropContainer } = action.payload;
      const dragSubName = dragContainer.name;
      const dropSubName = dropContainer.name;
      const { id: dragGroupId } = dragContainer.group;
      const { id: dropGroupId } = dropContainer.group;
      const { email } = dragUser;

      var srcGroup = state.groups.find((v) => v.id === dragGroupId);
      var desGroup = state.groups.find((v) => v.id === dropGroupId);

      var srcSubGroup = srcGroup.subGroups.find(s=>s.name === dragSubName);
      var index = srcSubGroup.members.findIndex((o) => o === email);
      srcSubGroup.members.splice(index, 1);

      var dstSubGroup = desGroup.subGroups.find(s=>s.name === dropSubName);
      dstSubGroup.members.push(email);
    },
    groupRemoveUser: (state, action) => {
      const { user, container } = action.payload;
      const subName = container.name;
      const groupId = container.group.id;
      const group = state.groups.find((g) => g.id === groupId);
      var subGroup = group.subGroups.find(s=>s.name === subName);
      const index = subGroup.members.findIndex((email) => email === user.email);
      subGroup.members.splice(index, 1);
    },
    groupAddUsers: (state, action) => {
      const { lst, container } = action.payload;
      const subName = container.name;
      const groupId = container.group.id;
      const group = state.groups.find((g) => g.id === groupId);
      const subGroup = group.subGroups.find(s=>s.name === subName);
      subGroup.members = subGroup.members.concat(lst);
    },
    replaceGroup: (state, action) => {
      var { group } = action.payload;
      var i = state.groups.findIndex((g) => g.id === group.id);
      if (i !== -1) {
        state.groups.splice(i, 1, group);
      }
    },
    deleteGroup: (state, action) => {
      const { groupId } = action.payload;
      const i = state.groups.findIndex((g) => g.id === groupId);
      if (i !== -1) {
        state.groups.splice(i, 1);
      }
    },
    editGroup: (state, action) => {
      const { id, changes } = action.payload;
      const g = state.groups.find((g) => g.id === id);
      if (g) {
        Object.keys(changes).forEach((key) => g[key] === changes[key]);
      }
    },
    editGroupName: (state, action) => {
      const { id, name } = action.payload;
      const g = state.groups.find((g) => g.id === id);
      if (g) {
        g.name = name;
      }
    },
    setKeys: (state, action) => {
      const { keys } = action.payload;
      state.filter.keys = keys;
    }, 
    setThanhPhans: (state, action) => {
      const { thanhPhans } = action.payload;
      state.filter.thanhPhans = thanhPhans;
    }, 
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDataAsync.fulfilled, (state, action) => {
        state.status = "idle";
        console.log("fetchWorkingTimeAsync", action);
        if (action.payload) {
          state.sheetData = action.payload.sheetData;
          state.sheetHdr = action.payload.sheetHdr;
        }
      })
      .addCase(fetchDataAsync.pending, (state) => {
        state.status = "loading";
      });
  },
});

export const {
  setSheetData,
  setSheetHdr,
  setCellData,
  setTaskRawId,
  setDaoTrangId,
  setActiveDaoTrang,
  setMembers,
  editUser,
  addUser,
  deleteUser,
  setDaoTrangs,
  addDaoTrang,
  editDaoTrang,
  deleteDaoTrang,
  updateActiveDaoTrang,
  addGroup,
  setGroupChecked,
  groupMoveUser,
  groupRemoveUser,
  groupAddUsers,
  replaceGroup,
  editGroup,
  editGroupName,
  deleteGroup,
  setKeys,
  setThanhPhans,
} = slice.actions;
export const selectSheetData = (state) => state.task.present.sheetData;
export const selectSheetHdr = (state) => state.task.present.sheetHdr;
export const selectTaskRawId = (state) => state.task.present.rawId;
export const selectDaoTrangId = (state) => state.task.present.daoTrangId;
export const selectMembers = (state) => state.task.present.members;
export const selectDaoTrangs = (state) => state.task.present.daoTrangs;
export const selectGroups = (state) => state.task.present.groups;
export const selectKeys = (state) => state.task.present.filter.keys;
export const selectThanhPhans = (state) => state.task.present.filter.thanhPhans;
export const selectDaoTrangById = (state, id) =>
state.task.present.daoTrangs && state.task.present.daoTrangs.find((dt) => dt.id === id);
// export const selectOldGroups = (state) => state.task.baseGroups;
export const selectGroupById = (state, id) =>
  state.task.present.groups.find((g) => g.id === id);
export const selectActiveDaoTrangId = (state) => state.task.present.daoTrangId;

export default slice.reducer;
function patch(entity,changes) {
  Object.keys(changes).forEach((key) => (entity[key] = changes[key]));
}

